export default __webpack_public_path__ + "static/media/FT2.a703bf5e.png";